<template>
  <div>
    <circle-loader ref="circleLoader" />
    <b-card class="md-3" id="main" v-if="!submitted">
      <p>Modificar roles y permisos</p>
      <div>
        <b-form @submit="updateRole">
          <div class="groupBox">
            <b-row>
              <b-col>

                <b-row>
                  <b-col>
                    <b-form-group
                    label-size="sm"
                    label="Seleccione un rol *"
                    label-for="roles"
                    >
                      <b-form-select id="roles" name="roles" size="sm" @change="getActionsInfo" v-model="aliasSelected">
                        <b-form-select-option
                          v-for="(roleAlias, index) in roleList"
                          v-bind:key="index"
                          v-bind:value="roleAlias"
                        >
                          {{ roleAlias }}
                        </b-form-select-option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <button type="button" class="btn btn-info" id="refresh" @click="resetValues">
                      <i class="fas fa-sync-alt"></i>
                      Refrescar
                    </button>
                  </b-col>
                </b-row>

                <b-row>
                  <b-form-group
                  label-size="sm"
                  label="Modificar alias"
                  label-for="alias"
                  v-if="optionSelected"
                  >
                    <b-form-input
                      id="alias"
                      name="alias"
                      size="sm"
                      list="previousAlias"
                      autocomplete="off"
                      v-model="newAlias"
                      required
                    ></b-form-input>
                    <datalist id="previousAlias">
                      <option>{{aliasSelected}}</option>
                    </datalist>
                  </b-form-group>
                </b-row>

                <b-row>
                  <b-card class="md" v-if="optionSelected">
                    <p>Descripción</p>
                    <small class="description" id="infoKey">{{keywordSelected? keywordSelected+":":""}}</small><br v-if="keywordSelected">
                    <small class="description">{{currentDescription? currentDescription:"Seleccione un permiso"}}</small>
                  </b-card>
                </b-row>

                <b-row>
                  <button type="submit" class="btn btn-success" id="savebtn" v-if="optionSelected">
                    <i class="fas fa-edit"></i>
                    Guardar rol
                  </button>
                </b-row>

                <b-row>
                  <button type="button" class="btn btn-danger" id="delbtn" v-if="optionSelected" @click="confirmDelete">
                    <i class="fas fa-trash-alt"></i>
                    Eliminar rol
                  </button>
                </b-row>

              </b-col>

              <b-col>
                <b-card class="md" v-if="optionSelected">
                  <p>Permisos concedidos</p>
                  <div class="actions">
                    <div 
                      class="shownAction" 
                      v-for="(keyword, indice) in currentKeywords"
                      v-bind:key="indice"
                      v-bind:value="keyword"
                    >  
                      <b-form-group>
                        <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="switchPermit"
                              v-text="keyword"
                              checked
                            />
                            <label class="form-check-label" for="switchPermit">{{keyword}}</label>
                            <img src="../../assets/images/info.png" alt="informacion" class="infoButton" @click="showDescription">
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                </b-card>
              </b-col>

              <b-col>
                <b-card class="md" v-if="optionSelected">
                  <p>Permisos no concedidos</p>
                  <div class="actions">
                    <div 
                      class="shownAction" 
                      v-for="(keyword, indice) in currentNonGrantedKeywords"
                      v-bind:key="indice"
                      v-bind:value="keyword"
                    >  
                      <b-form-group>
                        <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="switchPermit"
                              v-text="keyword"
                            />
                            <label class="form-check-label" for="switchPermit">{{keyword}}</label>
                            <img src="../../assets/images/info.png" alt="informacion" class="infoButton" @click="showDescription">
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                </b-card>
              </b-col>

            </b-row>
          </div>
        </b-form>
      </div>
    </b-card>
  </div>
</template>
<script>
import CircleLoader from "@/components/common/CircleLoader";
import UserService from "@/services/UserService";

export default {
  name: "edit-role",
  components: {
    "circle-loader": CircleLoader,
  },
  data() {
    return {
      roles: [],
      roleList: [],

      actions: [],
      keyWordList: [],
      descriptionList: [],

      currentKeywords: [],
      currentNonGrantedKeywords: [],
      currentDescription: null,
      keywordSelected: null,

      aliasSelected: null,
      newAlias: null,
      roleSelected: null,
      actionFocused: null,
      optionSelected: false,
      submitted: false,
    };
  },
  mounted() {
    this.retrieveInformation();
  },
  methods: {
    async updateRole(e) {
      e.preventDefault();
      let keywordArray = this.getAllPermits();
      let roleUpdate = {
        _id: this.roleSelected._id,
        alias: this.newAlias,
        sections: keywordArray
      };
      await UserService.updateRole(roleUpdate).then((response)=>{
        this.submitted = true;
          this.$refs.circleLoader.showLoading("Actualizando rol...");
          setTimeout(() => {
            if (
              !response.data.code ||
              response.data.code == 3000 ||
              response.status == 202
            ) {
              this.$refs.circleLoader.showEndError(response.data.message);
            } else {
              this.$refs.circleLoader.showEndSuccess(response.data.message);
            }
            setTimeout(() => {
              this.submitted = false;
              this.$refs.circleLoader.reset();
              this.resetValues();
            }, 1500);
          }, 2500);
      })
      .catch((e) => {
          console.log(e);
      });
    },
    async deleteRole(){
      let id = this.roleSelected._id
      await UserService.deleteRole(id).then((response)=>{
        this.submitted = true;
          this.$refs.circleLoader.showLoading("Eliminando rol...");
          setTimeout(() => {
            if (
              !response.data.code ||
              response.data.code == 3000 ||
              response.status == 202
            ) {
              this.$refs.circleLoader.showEndError(response.data.message);
            } else {
              this.$refs.circleLoader.showEndSuccess(response.data.message);
            }
            setTimeout(() => {
              this.submitted = false;
              this.$refs.circleLoader.reset();
              this.resetValues();
            }, 1500);
          }, 2500);
      })
      .catch((e) => {
          console.log(e);
      });
    },
    retrieveInformation(){
      UserService.getAllRoles()
      .then((response) => {
        this.roles = response.data;
        response.data.forEach((element) => {
          if(element.alias!="Administrador"){
            this.roleList.push(element.alias);
          }  
        });
      })
      .catch((err) => {
        console.log(err);
      });
      UserService.getAllActions()
      .then((response) => {
          this.actions = response.data;
          this.keyWordList = Object.keys(this.actions);
          this.keyWordList.forEach(key=>{
            this.descriptionList.push(this.actions[key].description);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActionsInfo(){
      this.optionSelected = true;
      this.currentDescription = "Seleccione un permiso";
      this.keywordSelected = null;
      this.newAlias = this.aliasSelected;
      this.roles.forEach(role=>{
        if(role.alias == this.aliasSelected){
          this.roleSelected = role;
          this.currentKeywords = role.sections;
        }
      });
      this.currentNonGrantedKeywords = this.keyWordList;
      this.currentKeywords.forEach(keyword=>{
        let sectionFound = false;
        this.roleSelected.sections.forEach(section =>{
          if(section==keyword){
            sectionFound = true;
          }
        });
        if(sectionFound){
          this.currentNonGrantedKeywords = this.arrayRemove(this.currentNonGrantedKeywords,keyword);
        }
      });
    },
    showDescription(e){
      let keyword = e.target.parentNode.childNodes[1].textContent;
      this.currentDescription = this.actions[keyword].description;
      this.keywordSelected = keyword;
    },
    arrayRemove(arr, value) { 
        return arr.filter(function(ele){ 
            return ele != value; 
        });
    },
    resetValues(){
      this.roles = [];
      this.roleList = [];
      this.actions = [];
      this.keyWordList = [];
      this.descriptionList = [];
      this.currentKeywords = [];
      this.currentNonGrantedKeywords = [];
      this.currentDescription = null;
      this.keywordSelected = null;
      this.aliasSelected = null;
      this.newAlias = null;
      this.roleSelected = null;
      this.actionFocused = null;
      this.optionSelected = false;
      this.retrieveInformation();
    },
    getAllPermits(){
      let permits = [];
      let checks = document.getElementsByName("switchPermit");
      for(let i=0;i<checks.length;i++){
        if(checks[i].checked){
          permits.push(checks[i].textContent);
        }
      }
      return permits;
    },
    confirmDelete(){
      let option = confirm("¿Está seguro de que desea eliminar el rol?");
      if (option) {
        this.deleteRole();
	    }
    }
  },
};
</script>

<style scoped>
p:first-child {
  margin-left: 40px;
}
.groupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 30px;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 30px;
  min-height: 200px;
}
#roles{
  width: 200px;
}
#main{
  min-height: 300px
}
.actions{
  width: 100%;
  max-height: 500px;
  overflow-y: scroll;
}
.shownAction{
  margin-left: 20px auto;
  margin-bottom: 5px;
  padding-top: 20px;
  padding-left: 40px;
  border: solid;
  border-color: rgb(0, 123, 255);
  border-radius: 10px;
  font-size: 90%;
}
.shownAction:hover{
  background-color: rgb(225, 239, 255);;
}
.shownAction label{
  margin-top: 7px;
  font-size: 90%;
}

.infoButton{
  margin-left: 10px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  float: right;
  margin-right: 15px;
  border-radius: 20px;
  border-width: 0px;
  opacity: 0.7;
}
.infoButton:hover{
  opacity: 1;
}
.form-check-input{
  margin-top: 10px;
}

#savebtn {
  margin-top: 15px;
  margin-bottom: 15px;
}
#savebtn, #delbtn{
  width: 170px;
}
.description{
  font-size: 110%;
}
#infoKey{
  font-weight: bold;
  color: rgb(0, 123, 255);
}
#refresh{
  font-size: 90%;
  margin-top: 35px;
}

</style>
